import * as t from 'io-ts';
import { Mixed } from 'io-ts';
import { CategoryEntity } from '../../interfaces/explore/CategoryEntity';
import { AllCategories } from './backend/explore_api';

type Validatable<T> = { [key in keyof T]-?: Mixed };

const CategoryEntityValidator: t.Type<CategoryEntity> = t.type<
  Validatable<CategoryEntity>
>({
  categoryId: t.number,
  nameJa: t.string,
  imageUrl: t.string,
});
export const CategoryArrayValidator: t.Type<CategoryEntity[]> = t.array(
  CategoryEntityValidator,
);
export const AllCategoriesValidator: t.Type<AllCategories> = t.type<
  Validatable<AllCategories>
>({
  categories: CategoryArrayValidator,
});
